import React from "react";
import { Link } from "react-router-dom";
import { createPageUrl } from "@/shared/utils";
import { ChevronRight, Zap, Users, Building2, Receipt } from "lucide-react";
import { useLanguage } from "@/shared/components/shared/LanguageContext";

export default function DrillDownBreadcrumb({ engine, reseller, merchant, transaction }) {
  let t = null;
  try {
    const langContext = useLanguage();
    t = langContext?.t;
  } catch (e) {
    // Not wrapped in LanguageProvider
  }
  const items = [];

  if (engine) {
    items.push({
      label: engine.name || engine.code || (t ? t("engine") : "Engine"),
      icon: Zap,
      href: createPageUrl("AdminEngineDetail") + `?id=${engine.id}`,
      color: "text-sky-600 bg-sky-100",
    });
  }

  if (reseller) {
    items.push({
      label: reseller.name || reseller.code || (t ? t("reseller") : "Reseller"),
      icon: Users,
      href: createPageUrl("AdminResellerDetail") + `?id=${reseller.id}`,
      color: "text-purple-600 bg-purple-100",
    });
  }

  if (merchant) {
    items.push({
      label: merchant.name || merchant.code || (t ? t("merchant") : "Merchant"),
      icon: Building2,
      href: createPageUrl("AdminMerchantDetail") + `?id=${merchant.id}`,
      color: "text-blue-600 bg-blue-100",
    });
  }

  if (transaction) {
    items.push({
      label: transaction.transaction_id || (t ? t("transaction") : "Transaction"),
      icon: Receipt,
      href: null,
      color: "text-emerald-600 bg-emerald-100",
    });
  }

  if (items.length === 0) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap bg-slate-50 rounded-lg px-4 py-2 border border-slate-200">
      <span className="text-xs text-slate-500 font-medium uppercase">{t ? t("hierarchy") : "Hierarchy"}:</span>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <ChevronRight className="h-4 w-4 text-slate-300" />}
          {item.href ? (
            <Link
              to={item.href}
              className="flex items-center gap-1.5 px-2 py-1 rounded-md hover:bg-white transition-colors"
            >
              <div className={`w-5 h-5 rounded flex items-center justify-center ${item.color}`}>
                <item.icon className="h-3 w-3" />
              </div>
              <span className="text-sm font-medium text-slate-700">{item.label}</span>
            </Link>
          ) : (
            <div className="flex items-center gap-1.5 px-2 py-1">
              <div className={`w-5 h-5 rounded flex items-center justify-center ${item.color}`}>
                <item.icon className="h-3 w-3" />
              </div>
              <span className="text-sm font-medium text-slate-900">{item.label}</span>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}